<template>
  <h3 class="section-title">
    <slot></slot>
  </h3>
</template>

<script>
export default {
  name: 'BaseSectionTitle'
}
</script>

<style scoped>
.section-title {
  font-family: '8bit', sans-serif;
  margin: 13px 0;
}
.section-title:first-letter {
  @apply inline-block bg-black text-white p-5 mr-2 text-3xl font-bold;
}
</style>
